import React, { useEffect, useState } from "react";
import axios from "axios";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import "../Styling/ViewResourceDetails.css";

const ViewResourceDetails = () => {
  const { user } = useAuth(); 

  const [resources, setResources] = useState([]);

  const fetchResources = async () => {
    try {
      const res = await axios.get(
         `${Base_URL}/ResourceMaster/all`,
        {
          params: {
            orgId: user?.organisationId, 
          },
        },
      );

      const data = res?.data?.data || res?.data?.Data || res?.data || [];

      const arrayData = Array.isArray(data) ? data : [data];

      const filteredData = arrayData.filter(
        (item) => item.organisationId === user?.organisationId,
      );

      setResources(filteredData);
    } catch (err) {
      console.error("Error fetching resources:", err);
    }
  };

  useEffect(() => {
    if (user?.organisationId) {
      fetchResources();
    }
  }, [user]);

  return (
    <div className="resource-dashboard-container">
      {/* Header */}
      <div className="resource-dashboard-header">
        <h2>Resource Details</h2>
      </div>

      {/* Summary */}

      <div className="resource-dashboard-summary">
        <div className="resource-card">
          <p>Organisation ID</p>
          <h3>{user?.organisationId || "N/A"}</h3>
        </div>

        <div className="resource-card">
          <p>Total Resources</p>
          <h3>{resources.length}</h3>
        </div>
      </div>

      {/* Table */}
      <div className="resource-dashboard-table-wrapper">
        <table className="resource-dashboard-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Resource ID</th>
              <th>DOB</th>
              <th>Joining Date</th>
              <th>Role</th>
              <th>Company Name</th>
              <th>Office</th>
              <th>Organisation</th>
              <th>Username</th>
              <th>Basic</th>
              <th>HRA</th>
              <th>Medical</th>
              <th>Conveyance</th>
              <th>Special</th>
              <th>Bonus</th>
              <th>Child Edu</th>
              <th>Gross</th>
              <th>PF</th>
            </tr>
          </thead>

          <tbody>
            {resources.length > 0 ? (
              resources.map((item, index) => (
                <tr key={index}>
                  <td>{item.resourceName}</td>
                  <td>{item.resourceId}</td>

                  <td>
                    {item.dob ? new Date(item.dob).toLocaleDateString() : ""}
                  </td>

                  <td>
                    {item.dateOfJoining
                      ? new Date(item.dateOfJoining).toLocaleDateString()
                      : ""}
                  </td>

                  <td>{item.offerRoleDesc}</td>
                  <td>{item.name}</td>
                  <td>{item.officeName}</td>
                  <td>{item.organisationName}</td>
                  <td>{item.username}</td>

                  <td>₹{item.basic}</td>
                  <td>₹{item.hra}</td>
                  <td>₹{item.medicalAllowance}</td>
                  <td>₹{item.conveyanceAllowance}</td>
                  <td>₹{item.specialAllowance}</td>
                  <td>₹{item.advanceStatutoryBonus}</td>
                  <td>₹{item.childEducationAllowance}</td>
                  <td>₹{item.gross}</td>
                  <td>₹{item.pfEmployee}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="19" className="no-data">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ViewResourceDetails;
